import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import TaskPayload from '../schemas/TaskPayload'
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax'
import formatTaskForApi from 'formatTaskForApi'

export default DataRequest({
  schema: TaskPayload,

  perform(task) {
    const data = formatTaskForApi(task);

    return ajax({
      url: `/api/learner/perform_tasks/${task.id}`,
      type: 'DELETE',
      data: { task: data }
    })
  },
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/data_requests/deleteTask.js